import { render, staticRenderFns } from "./Strategy.vue?vue&type=template&id=cc9549d4&scoped=true&"
import script from "./Strategy.vue?vue&type=script&lang=ts&"
export * from "./Strategy.vue?vue&type=script&lang=ts&"
import style0 from "./Strategy.vue?vue&type=style&index=0&id=cc9549d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9549d4",
  null
  
)

export default component.exports